<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
			<thead>
				<tr>
					<th style="text-align:center;width:60px;">Item ID</th>
					<th style="text-align:center;width:30px;">G. Ord.</th>
					<th style="text-align:center;width:80px;">G. Code</th>
					<th style="text-align:center;width:100px;">G. Name</th>
					<template v-if="user.company_id == 'jc'">
						<th style="text-align:center;width:120px;">Item Code</th>
						<th>Name</th>
					</template>
					<template v-else>
						<th style="text-align:center;width:120px;">{{ headers.class }} Code</th>
						<th v-if="user.company_id == 'newjigu'">Item Name</th>
						<th v-else>{{ headers.class }} Name</th>
						<th style="text-align:center;width:90px;">Color</th>
					</template>

					<th style="text-align:center;width:80px;">Barcode</th>
					<th style="text-align:center;width:50px;">Pcs(Box)</th>
					<template v-if="user.item_detail_view || user.admin">
						<th style="text-align:center;width:50px;">On Hand</th>
						<th style="text-align:center;width:60px;">LastShip</th>
						<th style="text-align:center;width:60px;">LastShip P.</th>

						<th style="text-align:center;width:50px;" v-if="user.cost_view_yn == 'Y' || user.admin">Cost($)</th>
						<th style="text-align:center;width:50px;">Min($)</th>
						<th style="text-align:center;width:50px;">Lock($)</th>

						<!-- <th style="text-align:center;width:4%;">S P.($)</th>
          <th style="text-align:center;width:4%;">A P.($)</th>
          <th style="text-align:center;width:4%;">B P.($)</th>
          <th style="text-align:center;width:4%;">C P.($)</th> -->

						<th style="text-align:center;width:50px;">Location</th>
						<th style="text-align:center;width:30px;">Rack</th>
						<th style="text-align:center;width:30px;">Sec.</th>
					</template>
					<th style="text-align:center;width:30px;">Active</th>

					<!-- <th style="text-align:center;width:3%;">Pack</th>
        <th style="text-align:center;width:3%;">Unit</th>

        <th style="text-align:center;width:4%;">Lock($)</th>
        <th style="text-align:center;width:4%;">Min($)</th>
        <th style="text-align:center;width:4%;" v-if="user.cost_view_yn == 'Y'">Cost($)</th>

        <th style="text-align:center;width:4%;">S P.($)</th>
        <th style="text-align:center;width:4%;">A P.($)</th>
        <th style="text-align:center;width:4%;">B P.($)</th>
        <th style="text-align:center;width:4%;">C P.($)</th>

        <th style="text-align:center;width:4%;">Loc.</th>
        <th style="text-align:center;width:2%;">Rack</th>
        <th style="text-align:center;width:2%;">Sec.</th>

        <th style="text-align:center;width:6%;">On Hand</th>

        <th style="text-align:center;width:3%;">Active</th> -->
				</tr>
			</thead>

			<tbody>
				<tr v-for="item in items" v-bind:key="item.item_id">
					<td>{{ item.item_id }}</td>
					<td class="al_right">{{ item.group_order_no }}</td>
					<td>{{ item.group_code }}</td>
					<td>{{ item.group_name }}</td>
					<template v-if="user.company_id == 'jc'">
						<td>{{ item.item_code }}</td>
						<td class="al_left truncate">{{ item.name }}</td>
					</template>
					<template v-else>
						<td>{{ item.class_code }}</td>
						<td v-if="user.company_id == 'newjigu'" class="al_left truncate">{{ item.name }}</td>
						<td v-else class="al_left truncate">{{ item.class_name }}</td>
						<td>{{ item.color_code }}</td>
					</template>

					<td>{{ item.barcode }}</td>
					<td style="text-align:right;">{{ item.packing | commaSeparated }}</td>
					<template v-if="user.item_detail_view || user.admin">
						<td style="text-align:right;">{{ item.on_hand | commaSeparated }}</td>
						<td>
							<a href="javascript:;" @click="selectShipment(item.last_sh_no)">{{ item.last_sh_no }}/{{ item.last_sh_dn }}</a>
						</td>
						<td style="text-align:right;">{{ item.last_sh_price | toCurrency }}</td>

						<td style="text-align:right;" v-if="user.cost_view_yn == 'Y' || user.admin">{{ item.cost | toCurrency }}</td>
						<td style="text-align:right;">{{ item.min_price | toCurrency }}</td>
						<td style="text-align:right;">{{ item.lock_price | toCurrency }}</td>

						<!-- <td style="text-align:right;">{{ item.s_price | toCurrency }}</td>
          <td style="text-align:right;">{{ item.a_price | toCurrency }}</td>
          <td style="text-align:right;">{{ item.b_price | toCurrency }}</td>
          <td style="text-align:right;">{{ item.c_price | toCurrency }}</td> -->

						<td>{{ item.location_name }}</td>
						<td>{{ item.rack }}</td>
						<td>{{ item.section }}</td>
					</template>
					<td style="text-align:center;">{{ item.active_yn }}</td>
					<!-- <td style="text-align:right;">{{ item.packing }}</td>
        <td>{{ item.unit_code }}</td>

        <td style="text-align:right;">{{ item.lock_price | toCurrency }}</td>
        <td style="text-align:right;">{{ item.min_price | toCurrency }}</td>
        <td style="text-align:right;" v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency }}</td>

        <td style="text-align:right;">{{ item.s_price | toCurrency }}</td>
        <td style="text-align:right;">{{ item.a_price | toCurrency }}</td>
        <td style="text-align:right;">{{ item.b_price | toCurrency }}</td>
        <td style="text-align:right;">{{ item.c_price | toCurrency }}</td>

        <td>{{ item.location_name }}</td>
        <td>{{ item.rack }}</td>
        <td>{{ item.section }}</td> -->

					<!-- <td style="text-align:right;">
          <currency-input type="text" :style="item.changed ? 'border:1px solid red' : 'border:1px solid #ddd'" v-model.trim="item.new_on_hand" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" />
        </td> -->
					<!-- <td style="text-align:right;">{{ item.on_hand | commaSeparated }}</td> -->

					<!-- <td style="text-align:center;">{{ item.closed_yn }}</td> -->
					<!-- <td style="text-align:center;">{{ item.active_yn }}</td> -->
				</tr>
			</tbody>
		</table>

		<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<!-- <table id="dataTable" class="list_tbl tbl_pointer" v-show="false">
			<thead>
				<tr>
					<th v-if="user.company_id != 'newjigu'">Item ID</th>
					<th>Item Name</th>
					<th>G. Ord.</th>
					<th>G. Code</th>
					<th>G. Name</th>
					<th>C. Code</th>
					<th>C. Name</th>
					<th>Color</th>
					<th>Barcode</th>
					<template v-if="user.item_detail_view || user.admin">
						<th>On Hand</th>
						<th>LastShip</th>
						<th>LastShip P.</th>
						<th>Cost($)</th>
						<th>Min($)</th>
						<th>Lock($)</th>
						<th>Rack</th>
						<th>Sec.</th>
					</template>
					<th>Active</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in exportItems" v-bind:key="index">
					<td v-if="user.company_id != 'newjigu'">{{ item.item_id }}</td>
					<td>{{ item.name }}</td>
					<td>{{ item.group_order_no }}</td>
					<td>{{ item.group_code }}</td>
					<td>{{ item.group_name }}</td>
					<td>{{ item.class_code }}</td>
					<td>{{ item.class_name }}</td>
					<td>{{ item.color_code }}</td>
					<td>{{ item.barcode }}</td>
					<template v-if="user.item_detail_view || user.admin">
						<td>{{ item.on_hand | commaSeparated }}</td>
						<td>{{ item.last_sh_dn }}</td>
						<td>{{ item.last_sh_price | toCurrency }}</td>
						<td>{{ item.cost | toCurrency }}</td>
						<td>{{ item.min_price | toCurrency }}</td>
						<td>{{ item.lock_price | toCurrency }}</td>
						<td>{{ item.rack }}</td>
						<td>{{ item.section }}</td>
					</template>
					<td>{{ item.active_yn }}</td>
				</tr>
			</tbody>
		</table> -->
		<div class="view_bottom_bt">
			<!-- <a href="javascript:;" :class="selectedItem.item_id && mode == 'detail' ? 'gray_bt' : 'disable_bt'" style="margin-right:15px" @click="inventoryHistory()">Inventory History</a>
      <span v-if="modifiable" class="int_type mgr_5">
        <select v-model="adjust_reason" class="tbl_select sm_int">
          <option value="adjust">Inventory Adjust</option>
          <option value="damage">Damage Loss</option>
          <option value="missing">Missing</option>
        </select>
      </span>
      <a v-if="modifiable" href="javascript:;" class="gray_bt" style="margin-right:15px" @click="adjustInventory()">Adjust On-Hand</a>
      <a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
      <a v-if="modifiable" href="javascript:;" :class="selectedItem.item_id && mode == 'detail' ? 'gray_bt' : 'disable_bt'" @click="clone()">Clone</a> -->
			<a href="javascript:void(0);" class="gray_bt" @click="exportExcel()">Excel</a>
		</div>
	</div>
</template>

<script>
import { apiSelectUpcInventoryItems } from '@/api/item/master.js';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';

import Paging from '@/components/common/Paging';
import { exportDataExcel, objectCopy, objectToFormData } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 26,
			page_no: 1,
			list_count: 0,
			active_yn: 'Y',
			saveParam: {},
			items: [],
			exportItems: [],

			item_classes_string: '',
			item_classes: [],

			keyword: null,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},
		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];
			//console.log(this.item_classes);

			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.keyword = '';
			this.active_yn = 'Y';

			this.item_classes_string = '';
			this.item_classes = [];
			this.allSelected = false;
		},
		selectShipment(sh_no) {
			let routeData = this.$router.resolve({
				name: 'shipmentDetail',
				params: { mode: 'detail' },
				query: { backUri: this.uri, sh_no: sh_no },
			});
			window.open(routeData.href, '_blank');
		},
		gotoPage(pageNo) {
			this.selectItems(pageNo);
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			this.item = {};

			const { data } = await apiSelectUpcInventoryItems(
				objectToFormData({
					paging_yn: this.paging_yn,
					page_size: this.page_size,
					page_no: this.page_no,
					start_index: this.page_size * (this.page_no - 1),
					w_ups_inventory: true,
					active_yn: this.active_yn,
					item_classes: this.item_classes,
					include_invoice_dn: true,
					keyword: this.keyword,
				}),
			);

			let saveParam = {
				w_ups_inventory: true,
				include_invoice_dn: true,
				paging_yn: 'N',
				active_yn: this.active_yn,
				item_classes: this.item_classes,
				keyword: this.keyword,
			};

			this.saveParam = objectCopy(saveParam);

			this.items = data.itemList;

			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/item/item_list?dummy=1';
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
			//console.log(uri);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			// if (this.items.length > 0) this.selectRow(this.items[0]);
			// else this.selectedItem = {};
		},
		async exportExcel() {
			//const vm = this;
			const { data } = await apiSelectUpcInventoryItems(objectToFormData(this.saveParam));

			let header = [
				{ key: 'item_id', name: 'Item ID', width: 15 },
				{ key: 'group_code', name: 'G. Code', width: 15 },
				{ key: 'group_name', name: 'G. Name', width: 15 },
				{ key: 'class_code', name: this.user.company_id == 'newjigu' ? 'Style' : 'C. Code', width: 15 },
				{ key: 'class_name', name: this.user.company_id == 'newjigu' ? 'Style Name' : 'C. Name', width: 15 },
				{ key: 'name', name: 'Item Name', width: 15 },
				{ key: 'color_code', name: 'Color', width: 15 },
				{ key: 'barcode', name: 'Barcode', width: 15 },
				{ key: 'packing', name: 'Psc(Box)', width: 10, dataType: defaultDataType.currency },
			];
			if (this.user.item_detail_view || this.user.admin) {
				header.push({ key: 'on_hand', name: 'On Hand', width: 10, dataType: defaultDataType.currency });
				header.push({ key: 'last_sh_dn', name: 'LastShip', width: 15 });
				header.push({ key: 'last_sh_price', name: 'LastShip P.', width: 10, dataType: defaultDataType.number });
				if (this.user.cost_view_yn == 'Y' || this.user.admin) header.push({ key: 'cost', name: 'Cost($)', width: 10, dataType: defaultDataType.number });
				header.push({ key: 'min_price', name: 'Min($)', width: 10, dataType: defaultDataType.number });
				header.push({ key: 'lock_price', name: 'Lock($)', width: 10, dataType: defaultDataType.number });
				header.push({ key: 'location_name', name: 'Location', width: 10 });
				header.push({ key: 'rack', name: 'Rack', width: 10 });
				header.push({ key: 'section', name: 'Sec.', width: 10 });
			}

			if (this.user.company_id != 'newjigu') {
				header.unshift({ key: 'group_order_no', name: 'G. Ord.', width: 10 });
				//header.unshift({ key: 'name', name: 'Item Name', width: 35 });
				header.push({ key: 'active_yn', name: 'Active', width: 10 });
			}

			exportDataExcel(data.itemList, header, 'ItemList_With_UPC&Inventory');
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_item_list');
		this.$store.commit('setSubTitle', 'Item -> Item List with UPC & Inventory');
	},
};
</script>

<style></style>
